import { render } from "./Checkbox.vue?vue&type=template&id=209c6b64&bindings={\"value\":\"props\",\"modelValue\":\"props\",\"binary\":\"props\",\"class\":\"props\",\"style\":\"props\",\"focused\":\"data\",\"onClick\":\"options\",\"onFocus\":\"options\",\"onBlur\":\"options\",\"checked\":\"options\",\"containerClass\":\"options\"}"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"
script.render = render

export default script